// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"sK-z","carouselContainer":"tK-z"};